// ─────────────────────────────────────────────────────────────────────────────
// logExport.js  (browser)
//
// Reports a gated export to the server so it can be audited against the user's
// REAL (signed) tier. Fire-and-forget: it must never block or break an export
// if the network/call fails. Call it from the PNG/TIFF save handlers.
//
//   import { logExport } from "./logExport";
//   logExport("savePng_8k");   // capability string from userTier.js CAPABILITIES
// ─────────────────────────────────────────────────────────────────────────────

import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./firebase";

const functions = getFunctions(app);
const _logExport = httpsCallable(functions, "logExport");

export async function logExport(capability) {
  try {
    await _logExport({ capability });
  } catch (err) {
    // Detection is best-effort; never let a logging failure affect the user.
    console.warn("logExport failed (non-blocking):", err);
  }
}
